import { Suspense } from 'react';
import { useLoaderData, json, defer, Await } from 'react-router-dom';

import AdvertiseServices from '../components/AdvertiseServices.jsx';

import classes from '../components/AdvertiseServices.module.css';

import { getAuthToken } from '../util/auth.jsx'
import backend from '../util/backend.jsx';

function AdvertiseServicesPage() {
  const info = useLoaderData();

  console.log(`AdvertiseServicesPage check: ${info.srv.max_order}`);

  return (
    <div className={classes.serviceslist}>
        <Suspense fallback={<p style={{ textAlign: 'center' }}>Loading...</p>}>
          <Await
            resolve={info.srv}
            children={(loadedSrv) => (<AdvertiseServices services={loadedSrv.data} min_order={loadedSrv.min_order["min_order"]} max_order={loadedSrv.max_order["max_order"]} />)}
          />
        </Suspense>
    </div>
  );
}

export default AdvertiseServicesPage;

async function loadAdSrv() {
  console.log('loadAdSrv: start');
  const token = getAuthToken();
  const response = await fetch(`https://${backend}/advertiseservices`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw json(
      { message: 'Could not query the current advertisement.' },
      {
        status: 500,
      }
    );
  } else {
    const resData = await response.json();
    //console.log(`loadAdSrv: ${JSON.stringify(resData)}`);
    let display_order = 0;
    let prev_order = -1;
    let min_order = 999999999999;
    let max_order = 0;
    let servicesData = resData;

    if (servicesData.length < 1) {
      console.log("AdvertiseServicesPage no data");
      const null_result = {
        min_order: {min_order},
        max_order: {max_order},
        data:      []
      }
      return null_result;
    }

    for (let index = 0; index < servicesData.length; index++) {
      //console.log(`loadAdSrv[${index}]: ${JSON.stringify(servicesData[index])}`);
      console.log(`loadAdSrv[${index}].id: ${servicesData[index].id}`);
      console.log(`loadAdSrv[${index}].display_order: ${servicesData[index].display_order}`);
      display_order = servicesData[index].display_order;
      if (index) {
        servicesData[index - 1].next_order = display_order;
        servicesData[index - 1].next_id = servicesData[index].id;
        servicesData[index].prev_order = prev_order;
        servicesData[index].prev_id = servicesData[index - 1].id;
      }
      if (display_order < min_order) {
        min_order = display_order;
      }
      if (display_order > max_order) {
        max_order = display_order;
      }
      prev_order = display_order;
    }
    const first = 0;
    const last = servicesData.length - 1;
    servicesData[first].prev_order = -1;
    servicesData[first].prev_id = -1;
    servicesData[last].next_order = -1;
    servicesData[last].next_id = -1;

    const result = {
      min_order: {min_order},
      max_order: {max_order},
      data:      servicesData
    }
    //console.log(`Advertise Services Result: ${JSON.stringify(result)}`);
    return result;
  }
}

export function loader() {
  console.log('Advertise Services Loader');
  return defer({
    srv: loadAdSrv(),
  });
}
